const FETCH_REQUEST = 'FETCH_REQUEST';
const FETCH_PRODUCTS_SUCCESS = 'FETCH_PRODUCTS_SUCCESS';
const CART_FETCH_SUCCESS = 'CART_FETCH_SUCCESS';
const FETCH_FAIL = 'FETCH_FAIL';

const CART_UPDATE_REQUEST = 'CART_UPDATE_REQUEST';
const CART_UPDATE_SUCCESS = 'CART_UPDATE_SUCCESS';
const CART_UPDATE_FAIL = 'CART_UPDATE_FAIL';
const CART_RESET = 'CART_RESET';

export {
   FETCH_REQUEST,
   FETCH_PRODUCTS_SUCCESS,
   CART_FETCH_SUCCESS,
   FETCH_FAIL,
   CART_UPDATE_REQUEST,
   CART_UPDATE_SUCCESS,
   CART_UPDATE_FAIL,
   CART_RESET,
};
